var Static = require('./Static');

Static( 'Contact', "http://johnsonbanks.webfactional.com/index.php/contact" )